import { render } from "./HorsesCreating.vue?vue&type=template&id=54795451&scoped=true&ts=true"
import script from "./HorsesCreating.vue?vue&type=script&lang=ts"
export * from "./HorsesCreating.vue?vue&type=script&lang=ts"

import "./HorsesCreating.vue?vue&type=style&index=0&id=54795451&scoped=true&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54795451"]])

export default __exports__